<section class="request" *ngIf="replacedData">
  <h5 class="request--title">{{ 'replacedVehicleData' | i18next }}</h5>
  <div class="replacedData">
    <div class="rowInfo d-flex flex-wrap gap-0 align-items-stretch">
      <p class="label col-12 col-lg-6">
        {{ 'model' | i18next }}
      </p>
      <p class="text">
        {{ replacedData.model ? replacedData.model : emptyData }}
      </p>
    </div>
    <div class="rowInfo d-flex flex-wrap gap-0 align-items-stretch">
      <p class="label col-12 col-lg-6">
        {{ 'deliveryDate' | i18next }}
      </p>
      <p class="text">
        {{ replacedData.deliveryDate ? replacedData.deliveryDate : emptyData }}
      </p>
    </div>

    <div class="rowInfo d-flex flex-wrap gap-0 align-items-stretch">
      <p class="label col-12 col-lg-6">
        {{ 'plateNumber' | i18next }}
      </p>
      <p class="text">
        {{ replacedData.plateNumber ? replacedData.plateNumber : '-' }}
      </p>
    </div>
    <div class="rowInfo d-flex flex-wrap gap-0 align-items-stretch">
      <p class="label col-12 col-lg-6">{{ 'currentKm' | i18next }}</p>
      <p class="text">
        {{ replacedData.estimatedKms ? replacedData.estimatedKms : '-' }}
      </p>
    </div>
  </div>
</section>
